export default __webpack_public_path__ + "static/media/70.637bf8d2.svg";